import { render, staticRenderFns } from "./BaseDetailsInfo.vue?vue&type=template&id=f16701fe&scoped=true"
import script from "./BaseDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDetailsInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseDetailsInfo.vue?vue&type=style&index=0&id=f16701fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16701fe",
  null
  
)

export default component.exports